import { useEffect } from "react";

export const useKeyboardToggle = (key: KeyboardEvent["key"], toggleHandler: () => void) => {
  useEffect(() => {
    if (!location.host.match(/banknorwegian|stage/)) {
      const isSingleLetter = /^[a-z]$/i.test(key);
      const expectedCode = isSingleLetter ? `Key${key.toUpperCase()}` : undefined;

      const themeChangeByKeyListener = function (this: Window, event: KeyboardEvent): void {
        const matchesKey = event.key === key.toLowerCase() || event.key === key.toUpperCase();
        const matchesCode = expectedCode !== undefined && event.code === expectedCode;

        if (event.altKey && (matchesKey || matchesCode)) {
          toggleHandler();
        }
      };
      window.addEventListener("keydown", themeChangeByKeyListener);
      return () => window.removeEventListener("keydown", themeChangeByKeyListener);
    }
  }, []);
};
